import { useState } from "react";

export interface ITabPallet {
  id: number;
  name: string;
}

export enum TabPalletIDs {
  LOADED = 1,
  UNLOADED = 2,
  ALL = 3
}



export const TAB_LIST: ITabPallet[] = [
  { id: TabPalletIDs.LOADED, name: "Loaded" },
  { id: TabPalletIDs.UNLOADED, name: "Unloaded" },
  { id: TabPalletIDs.ALL, name: "הכל" },
]



const useTabsPallet = () => {
  const defaultTab = TAB_LIST[2]
  const [activeTab, setActiveTab] = useState<ITabPallet>(defaultTab);  
  const handleSelectTab = (tab: ITabPallet) => {
    setActiveTab(tab);
  }
  return { 
    TAB_LIST,
    activeTab,
    handleSelectTab,
   };
} 

export default useTabsPallet;